"use client";

import { useCallback, useRef, useState } from "react";
import Image from "next/image";
import { useRouter } from "next/navigation";

import type { Tag as TagType } from "@/themes/ci/blog/types";

import Tag from "./Tag";
const styles = new Proxy({"SearchBar":"SearchBar-9dd64","InputGroup":"InputGroup-9dd64","Tags":"Tags-9dd64","TagsToggle":"TagsToggle-9dd64","TagsClosed":"TagsClosed-9dd64"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import searchbarMagnifyingGlass from "@/themes/kinerva-v2/blog/searchbar-magnifying-glass.png";
import searchbarArrowDown from "@/themes/kinerva-v2/blog/searchbar-arrow-down.png";

const SearchBar = ({ tags }: { tags: TagType[] }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [toggle, setToggle] = useState(false);
  const router = useRouter();

  const onKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") {
        if (!inputRef.current) return;
        const value = inputRef.current.value.trim();
        if (value) {
          inputRef.current.value = "";
          const params = new URLSearchParams();
          params.set("search", value);
          router.push(`/blog/1?${params.toString()}`);
        }
      }
    },
    [inputRef, router],
  );

  const uniqueTags = tags.filter(
    (tag, idx, self) => self.findIndex((t) => t.slug === tag.slug) === idx,
  );

  const tagStyle = [styles.Tags, toggle || styles.TagsClosed]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={styles.SearchBar}>
      <div className={styles.InputGroup}>
        <input
          id="search-input"
          type="text"
          ref={inputRef}
          onKeyDown={onKeyDown}
          placeholder="Search posts…"
        />
        <Image
          src={searchbarMagnifyingGlass}
          alt="Search"
          width={30}
          height={30}
          style={{ flexShrink: 0 }}
        />
      </div>

      <div className={tagStyle}>
        <span
          style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: 16,
            lineHeight: "30px",
            color: "#3BB1E6",
            fontWeight: 400,
            marginRight: 4,
          }}
        >
          Tag filter:
        </span>
        {uniqueTags.map((tag) => (
          <Tag key={tag.id} tag={tag} />
        ))}
      </div>

      <button
        type="button"
        className={styles.TagsToggle}
        onClick={() => setToggle((t) => !t)}
      >
        <Image
          src={searchbarArrowDown}
          alt="Toggle tags"
          width={46}
          height={32}
          style={{
            transform: toggle ? "rotate(180deg)" : "none",
            transition: "transform 0.2s",
          }}
        />
      </button>
    </div>
  );
};

export default SearchBar;
